const YoutubeRed = () => (
  <svg width="35" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M33.353 3.748A4.28 4.28 0 0 0 30.34.717C27.684 0 17.032 0 17.032 0S6.38 0 3.724.717a4.28 4.28 0 0 0-3.012 3.03C0 6.422 0 12 0 12s0 5.578.712 8.252a4.28 4.28 0 0 0 3.011 3.032C6.38 24 17.032 24 17.032 24s10.652 0 13.309-.716a4.28 4.28 0 0 0 3.011-3.031c.712-2.675.712-8.253.712-8.253s0-5.579-.712-8.252"
      className="fill-white"
    />
    <path
      d="M13.548 17.065 22.451 12l-8.903-5.065v10.13Z"
      className="fill-[#ff0000]"
    />
  </svg>
)

export default YoutubeRed
